import { useState, useEffect } from "react";

export default function CreateOrganisationModal({
  isOpen,
  onClose,
  onSubmit,
  orgData
}) {

  const initialState = {
    organisation_name: "",
    cin: "",
    pan: "",
    address: "",
    industry: "",
    contact_name: "",
    email: "",
    phone: "",
    password: ""
  };

  const [formData, setFormData] = useState(initialState);

  // useEffect(() => {

  //   if (orgData) {
  //     setFormData({
  //       organisation_name: orgData.organization_name || "",
  //       cin: orgData.cin || "",
  //       pan: orgData.pan || "",
  //       address: orgData.address || "",
  //       industry: orgData.industry || "",
  //       contact_name: orgData.primary_contact_name || "",
  //       email: orgData.primary_email || "",
  //       phone: orgData.primary_phone || "",
  //       password: ""
  //     });
  //   } else {
  //     setFormData(initialState);
  //   }

  // }, [orgData]);

  // In CreateOrganisationModal.jsx
useEffect(() => {
  if (orgData) {
    setFormData({
      organisation_name: orgData.organization_name || "",
      cin:               orgData.cin               || "",
      pan:               orgData.pan               || "",
      address:           orgData.address           || "",
      industry:          orgData.industry          || "",
      contact_name:      orgData.primary_contact_name || "",
      email:             orgData.primary_email     || "",
      phone:             orgData.primary_phone     || "",
      password:          ""
    });
  } else {
    setFormData(initialState);
  }
}, [orgData, isOpen]); // ✅ added isOpen
  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const success = await onSubmit(formData);

    if (success) {
      setFormData(initialState);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="modal-overlay">

      <div className="modal-container">

        <div className="modal-header">
          <h2>{orgData ? "Edit Organisation" : "Create Organisation"}</h2>
          <button className="modal-close" onClick={onClose}>✕</button>
        </div>

        <form onSubmit={handleSubmit}>

          <div className="form-section">

            <input
              type="text"
              name="organisation_name"
              placeholder="Organisation Name"
              value={formData.organisation_name}
              onChange={handleChange}
              required
            />

            <input
              type="text"
              name="cin"
              placeholder="CIN"
              value={formData.cin}
              onChange={handleChange}
            />

            <input
              type="text"
              name="pan"
              placeholder="PAN"
              value={formData.pan}
              onChange={handleChange}
            />

            <input
              type="text"
              name="industry"
              placeholder="Industry"
              value={formData.industry}
              onChange={handleChange}
            />

            <textarea
              name="address"
              placeholder="Complete Address"
              value={formData.address}
              onChange={handleChange}
              rows="4"
              className="form-textarea"
            />

          </div>

          <div className="form-section">

            <input
              type="text"
              name="contact_name"
              placeholder="Primary Contact Name"
              value={formData.contact_name}
              onChange={handleChange}
              required
            />

            <input
              type="email"
              name="email"
              placeholder="Email Address"
              value={formData.email}
              onChange={handleChange}
              required
            />

            <input
              type="text"
              name="phone"
              placeholder="Phone Number"
              value={formData.phone}
              onChange={handleChange}
              required
            />

            <input
              type="password"
              name="password"
              placeholder="Password (leave blank to keep same)"
              value={formData.password}
              onChange={handleChange}
            />

          </div>

          <div className="modal-footer">

            <button
              type="button"
              className="btn-secondary"
              onClick={onClose}
            >
              Cancel
            </button>

            <button
              type="submit"
              className="btn-primary"
            >
              {orgData ? "Update Organisation" : "Create Organisation"}
            </button>

          </div>

        </form>

      </div>

    </div>
  );
}